// extracted by mini-css-extract-plugin
export var cartContainer = "_q5-4";
export var gray = "_q5-1";
export var itemContainer = "_q5-2";
export var itemDetails = "_q5-3";
export var strong = "_q5-0";